import React from "react"
import Card from "../../../../components/Card/Card"
import AuthorHeader from "../AuthorHeader"
import TicketActivity from "../TicketActivity"
import Hr from "../../../../components/Hr"

const TicketResume = ({
    ticket
}) => {
    return (
        <Card className="min-h-18">
            <div>
                <AuthorHeader
                    email={ticket.author?.email}
                    name={ticket.author?.name}
                    avatar={ticket.author?.avatar}
                    datetime={ticket.createdAt}
                />
            </div>

            <div style={{ marginTop: 10, marginBottom: 10 }}>
                <Hr />
            </div>

            <div>
                <TicketActivity
                    contentHtml={ticket.description}
                />
            </div>
        </Card>
    )
}

export default TicketResume